import { useField, useForm } from "@taskfortress/core"
import type { Task } from "@taskfortress/core/src/clientData/contentTypes"
import { type SampleTask } from "@taskfortress/core/src/utils/randomStrings"
import React from "react"
import { Box } from "../../Box"
import { Button } from "../../Button"
import { DeleteItemButton } from "../../DeleteItemButton"
import { Text } from "../../Text"
import { DateInput, Form, TagField, TextArea, ToggleField } from "../../form"

interface TaskModalMobileProps {
  titleField: ReturnType<typeof useField<string>>
  descriptionField: ReturnType<typeof useField<string>>
  statusField: ReturnType<typeof useField<boolean>>
  dueDateField: ReturnType<typeof useField<Date>>
  tagsField: ReturnType<typeof useField<string[]>>
  form: ReturnType<typeof useForm>
  handleFormSubmit: (e?: React.FormEvent) => void
  handleDeleteTask: () => void
  saveButtonText: string
  sampleTask: SampleTask
  tagSuggestions: string[]
  task: Task
  onDelete?: (task: Task) => void
  isVisible: boolean
}

export const TaskModalMobile: React.FC<TaskModalMobileProps> = ({
  titleField,
  descriptionField,
  statusField,
  dueDateField,
  tagsField,
  form,
  handleFormSubmit,
  handleDeleteTask,
  saveButtonText,
  sampleTask,
  tagSuggestions,
  task,
  onDelete,
  isVisible,
}) => {
  const handleButtonPress = () => {
    handleFormSubmit()
  }

  return (
    <Box className="flex-1">
      <Form onSubmit={handleFormSubmit} error={form.formError}>
        {/* Task Title */}
        <TextArea
          {...titleField}
          label="Task"
          placeholder={sampleTask.title}
          rows={2}
          className="mb-4"
          autofocus={isVisible && !task.title}
        />

        {/* Task Description */}
        <TextArea
          {...descriptionField}
          label="Description"
          placeholder={sampleTask.description}
          rows={6}
          className="mb-4"
        />

        {/* Status Toggle */}
        <ToggleField
          value={!!statusField.value}
          handleChange={statusField.handleChange}
          label="Status"
          name="status"
          className="mb-4"
          afterToggle={
            <Box className="flex flex-col gap-2">
              <Text className="text-sm text-muted-foreground">
                {statusField.value ? "Done" : "To Do"}
              </Text>
            </Box>
          }
        />

        {/* Due Date */}
        <DateInput {...dueDateField} label="Due Date" className="mb-4" />

        {/* Tags */}
        <TagField
          {...tagsField}
          suggestions={tagSuggestions}
          label="Tags"
          className="mb-6"
        />

        {/* Submit Button */}
        <Box className="flex justify-between items-center">
          <Button variant="primary" onPress={handleButtonPress}>
            {saveButtonText}
          </Button>

          <DeleteItemButton
            onConfirm={handleDeleteTask}
            disabled={!onDelete || !task.id}
          />
        </Box>
      </Form>
    </Box>
  )
}
